var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 108,
    viewBox: "0 0 124 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M34 4h47.656L89 9.864l8 9.734V77H34z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00539D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.966 88.423h4.4v6.134h-4.4zM65.967 102.892h-2.2v4.4h6.599v-6.6h-4.4zM47.716 102.891h8.025v4.4h-8.025zM15.616 102.891h8.025v4.4h-8.025zM31.666 102.891h8.025v4.4h-8.025zM5.39 100.692H.991v6.6h6.6v-4.4h-2.2zM.991 52.541h4.4v8.025h-4.4zM.991 68.591h4.4v8.025h-4.4zM.991 84.641h4.4v8.025h-4.4zM.991 44.516h4.4v-2.2h2.2v-4.4H.99zM15.02 37.916h7.429v4.4H15.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.858 65.988a2.228 2.228 0 0 0-1.507-1.595l-23.397-6.996V19.514a2.163 2.163 0 0 0-.649-1.551L81.135.782a2.163 2.163 0 0 0-1.551-.65H34.276a2.206 2.206 0 0 0-2.2 2.2v35.584h-2.2v4.4h2.2V80.09h33.89v2.2h4.4v-2.2h15.675l4.796 14.729a2.23 2.23 0 0 0 1.562 1.452c.172.043.35.065.527.066a2.231 2.231 0 0 0 1.53-.616l9.24-8.877 8.293 8.294c.86.858 2.253.858 3.113 0l7.04-7.04c.415-.414.648-.976.649-1.562a2.163 2.163 0 0 0-.65-1.551l-8.073-8.085 9.174-8.81c.564-.541.799-1.341.616-2.101zM81.476 7.338L91.739 17.61H81.476V7.337zm13.079 48.739l-14.08-4.213a2.2 2.2 0 0 0-2.717 2.794l6.853 21.031H36.476V4.532h40.6v15.279a2.206 2.206 0 0 0 2.2 2.2h15.278v34.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.129 29.16a1.648 1.648 0 0 1-1.65 1.65H45.705a1.65 1.65 0 0 1 0-3.3h38.774a1.648 1.648 0 0 1 1.65 1.65zM86.129 37.146a1.648 1.648 0 0 1-1.65 1.65H45.705a1.65 1.65 0 1 1 0-3.3h38.774a1.648 1.648 0 0 1 1.65 1.65zM86.129 45.143a1.648 1.648 0 0 1-1.65 1.65H45.705a1.65 1.65 0 0 1 0-3.3h38.774a1.648 1.648 0 0 1 1.65 1.65z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/files-icon.d0da718c.svg";
export { ForwardRef as ReactComponent };